export default __webpack_public_path__ + "static/media/024-banners.3ea65ac5.svg";